<template>
  <div class="columns is-multiline">
    <div class="column is-3" v-for="creditcard in creditcards">
      <figure class="image is-autoby200">
        <img v-document="creditcard.document">
      </figure>
      <div class="columns receipt_footer">
        <div class="column">
          <div class="box-footer">
            <router-link class="button is-primary is-pulled-right" :to="{ name: 'creditcard.edit', params: { id: creditcard.id } }" exact>Invoeren</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-padding-fix column is-5" v-if="creditcards.length <= 0">
      <article class="message is-info">
        <div class="message-header">
          <p>Geen slips gevonden</p>
        </div>
        <div class="message-body">
          Upload een nieuwe creditcard slip om verwerkt te worden.
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      creditcards: 'incompleteCreditcardslips'
    })
  },
  async created () {
    try {
      await this.$store.dispatch('getIncompleteCreditcardslips')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens ophalen van de creditcard slips.'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creditcard/processing.vue